import { CheckCircle2, FileText, MessageSquare, Hammer, Phone } from "lucide-react";

const HowItWorks = () => {
  const steps = [
    {
      icon: MessageSquare,
      title: "Preencha o cadastro no site",
      description: "Responda algumas perguntas simples sobre você e sua casa"
    },
    {
      icon: Phone,
      title: "A equipe da Taboca entra em contato",
      description: "Fazemos uma análise gratuita e te orientamos sobre as possibilidades"
    },
    {
      icon: CheckCircle2,
      title: "Orientação sobre o financiamento",
      description: "Te ajudamos a entender como acessar o programa da Caixa"
    },
    {
      icon: FileText,
      title: "Projeto e orçamento da reforma",
      description: "A Taboca prepara todo o planejamento técnico da sua obra"
    },
    {
      icon: Hammer,
      title: "Acompanhamento da obra",
      description: "Ficamos com você do começo ao fim, garantindo qualidade"
    }
  ];

  return (
    <section id="como-funciona" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-4 text-foreground">
            Como <span className="text-[hsl(var(--orange-strong))]">funciona</span> o programa?
          </h2>
          
          <p className="text-center text-lg text-muted-foreground mb-16 max-w-2xl mx-auto">
            Um processo simples e claro, pensado para te acompanhar em cada passo
          </p>

          <div className="relative">
            {/* Timeline line - hidden on mobile */}
            <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-[hsl(var(--orange-strong))] to-[hsl(var(--golden))]" />

            <div className="space-y-12 md:space-y-16">
              {steps.map((step, index) => {
                const Icon = step.icon;
                const isEven = index % 2 === 0;
                
                return (
                  <div 
                    key={index}
                    className={`relative flex flex-col md:flex-row items-center gap-6 ${
                      isEven ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    {/* Content Card */}
                    <div className={`flex-1 ${isEven ? 'md:text-right' : 'md:text-left'}`}>
                      <div className="bg-card rounded-2xl p-6 md:p-8 shadow-[var(--shadow-card)] hover:shadow-[var(--shadow-warm)] transition-all">
                        <div className={`flex items-center gap-4 mb-4 ${isEven ? 'md:flex-row-reverse' : 'md:flex-row'}`}>
                          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[hsl(var(--orange-strong))] to-[hsl(var(--orange-medium))] flex items-center justify-center flex-shrink-0 md:hidden">
                            <Icon className="h-6 w-6 text-white" />
                          </div>
                          <h3 className="font-bold text-xl text-foreground">{step.title}</h3>
                        </div>
                        <p className="text-muted-foreground text-lg">{step.description}</p>
                      </div>
                    </div>

                    {/* Center Icon */}
                    <div className="hidden md:flex relative z-10 w-20 h-20 rounded-full bg-gradient-to-br from-[hsl(var(--orange-strong))] to-[hsl(var(--orange-medium))] flex items-center justify-center shadow-[var(--shadow-warm)] flex-shrink-0">
                      <Icon className="h-10 w-10 text-white" />
                      <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-[hsl(var(--golden))] text-white flex items-center justify-center font-bold text-sm shadow-md">
                        {index + 1}
                      </div>
                    </div>

                    {/* Empty space for layout balance */}
                    <div className="flex-1 hidden md:block" />

                    {/* Mobile step number */}
                    <div className="absolute -left-8 top-0 w-8 h-8 rounded-full bg-[hsl(var(--golden))] text-white flex items-center justify-center font-bold text-sm shadow-md md:hidden">
                      {index + 1}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
